import Layout from "@/layout";
import { Result } from "antd";

const ErrorPage = () => {
  const style: React.CSSProperties = {
    fontFamily: "Satoshi-Bold",
    fontWeight: "bold",
    fontSize: "24px",
    color: "#898989",
    textAlign: "center"
  };
  return (
    <Layout>
      <Result status="500" />
      <div style={style}>Sorry, something went wrong.</div>
    </Layout>
  );
};

export default ErrorPage;
